<h2 mat-dialog-title>Add DNS Zone</h2>

<button type="button" class="status-modal__close" aria-label="Close modal" (click)="close()">
  <fa-icon [icon]="['fas', 'xmark']" size="xl" />
</button>

<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Server"
      placeholder="Select server"
      type="autocomplete"
      formControlName="server"
      [options]="(servers$ | async) || []"
      [(searchText)]="serverSearchText"
    ></app-input-field>

    <app-input-field
      label="Website"
      placeholder="Select website"
      type="autocomplete"
      formControlName="websiteId"
      [options]="websiteOptions()"
      [(searchText)]="websiteSearchText"
    ></app-input-field>

    <mat-checkbox formControlName="overwrite"> Overwrite an existing DNS Zone </mat-checkbox>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button matButton="filled" [disabled]="form.invalid" (click)="submit()">Add DNS Zone</button>

  <button matButton="outlined" (click)="close()">Close</button>
</mat-dialog-actions>
